import {
    Globe,
    Smartphone,
    PenTool,
    Compass,
    ClipboardList,
    Code2,
    FlaskConical,
    Rocket,
    LifeBuoy,
    Braces,
    FileCode2,
    Atom,
    Layers,
    Server,
    Database,
    DatabaseZap,
    Flame,
    GitBranch,
    Container,
    Terminal,
    Coffee,
    Brain,
    Network,
    Cpu,
    Gem,
    MessageCircle,
    Lightbulb,
    Puzzle,
} from "lucide-react";

export const NAV_IDS = ["home", "services", "portfolio", "process", "technologies", "testimonials", "about", "contact"];

export const SERVICE_ICONS = [Globe, Smartphone, PenTool];

export const PROJECT_MEDIA = [
    {
        image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1600&q=80",
        tech: ["React", "Node.js", "PostgreSQL", "AI Integration"],
        featured: true,
    },
    {
        image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=1200&q=80",
        tech: ["Kotlin", "Firebase", "REST APIs"],
        featured: false,
    },
    {
        image: "https://images.unsplash.com/photo-1561070791-2526d30994b5?auto=format&fit=crop&w=1200&q=80",
        tech: ["Next.js", "TypeScript", "Laravel"],
        featured: false,
    },
];

export const PROCESS_ICONS = [Compass, ClipboardList, PenTool, Code2, FlaskConical, Rocket, LifeBuoy];

export const TECHNOLOGIES = [
    { name: "HTML5", icon: FileCode2 },
    { name: "CSS3", icon: Layers },
    { name: "JavaScript", icon: Braces },
    { name: "TypeScript", icon: FileCode2 },
    { name: "React", icon: Atom },
    { name: "Next.js", icon: Layers },
    { name: "Node.js", icon: Server },
    { name: "PHP", icon: Terminal },
    { name: "Laravel", icon: Cpu },
    { name: "Kotlin", icon: Smartphone },
    { name: "Java", icon: Coffee },
    { name: "Android Studio", icon: Smartphone },
    { name: "Firebase", icon: Flame },
    { name: "MySQL", icon: Database },
    { name: "PostgreSQL", icon: DatabaseZap },
    { name: "REST APIs", icon: Network },
    { name: "AI Integration", icon: Brain },
    { name: "Git", icon: GitBranch },
    { name: "Docker", icon: Container },
];

export const STAT_VALUES = [
    { value: 40, suffix: "+" },
    { value: 25, suffix: "+" },
    { value: 5, suffix: "+" },
    { value: 15, suffix: "+" },
];

export const TESTIMONIAL_META = [
    { name: "Sarah Mitchell", avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80" },
    { name: "David Chen", avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=200&q=80" },
    { name: "Emma Rodriguez", avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80" },
];

export const ABOUT_VALUE_ICONS = [Gem, MessageCircle, Lightbulb, Puzzle];

export const SOCIALS = {
    email: "overlast@overlastinc.com",
    linkedin: "https://www.linkedin.com/in/attilazsok",
    github: "https://github.com/attilazsok",
    whatsapp: "https://wa.me/36301234567",
};
